module.exports = {
  COMMUNICATION: {
    NOT_APPLICABLE: 'NOT_APPLICABLE',
    ENABLED: 'ENABLED',
    DISABLED: 'DISABLED'
  },
  COMMUNICATION_CONFIG_STATUS: {
    ENABLED: 'ENABLED',
    DISABLED: 'DISABLED'
  },
  COMMUNICATION_CONFIG_ATTACHMENT: {
    YES: 'YES',
    NO: 'NO'
  }
};
